import { CustomPortableText } from 'shared/studio/PortableText';
import { SanityKeyed, ArticleKeyTakeaways } from 'types/studio/studio';
import { Typography, Space } from '@ag1/ui';
import styles from './EduArticleKeyTakeaways.module.scss';

export const EduArticleKeyTakeaways = ({ headline, list }: SanityKeyed<ArticleKeyTakeaways>) => (
  <>
    <Space top={{ xxs: 24 }} />
    <div className={styles.container}>
      {headline && (
        <Typography
          component="div"
          variant="headline"
          size="2"
          noPadding
          className={styles.headline}
          color="black-new">
          <CustomPortableText value={headline} />
        </Typography>
      )}
      <ul className={styles.list}>
        {list.map((item, index) => (
          <li key={item._key} className={styles.listItem}>
            <Typography
              component="div"
              variant="body"
              size="1"
              noPadding
              weight="400"
              className={styles.number}
              color="black-new">
              {index + 1 < 10 ? `0${index + 1}.` : `${index + 1}.`}
            </Typography>
            <Typography
              component="div"
              variant="body"
              size="1"
              noPadding
              weight="400"
              className={styles.text}
              color="black-new">
              <CustomPortableText value={item.text} />
            </Typography>
          </li>
        ))}
      </ul>
    </div>
  </>
);
